import { Group, Stack, Text, ActionIcon } from "@mantine/core";
import { AppIcon } from "./AppIcon";

/**
 * Shared header for the "attention" and "live activity" panels:
 * a leading node (dot or icon), a title + subtitle, and the ••• / eye actions.
 */
export function PanelHeader({ leading, title, subtitle }) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" mb="md">
      <Group gap="sm" wrap="nowrap" align="center">
        {leading}
        <Stack gap={0}>
          <Text fw={700} fz="lg">
            {title}
          </Text>
          <Text fz="sm" c="gray.6">
            {subtitle}
          </Text>
        </Stack>
      </Group>
      <Group gap={4} wrap="nowrap">
        <ActionIcon variant="subtle" color="gray" aria-label="Options">
          <AppIcon name="dots" size={18} />
        </ActionIcon>
        <ActionIcon variant="subtle" color="gray" aria-label="Voir tout">
          <AppIcon name="eye" size={18} />
        </ActionIcon>
      </Group>
    </Group>
  );
}

export default PanelHeader;
